import { theme } from '../styles/theme';

const { grey, lightGreen, darkGreen, pink, yellow, red } = theme.colors;

function colourMatching(colour) {
  switch (colour) {
    case 'white':
      return 'white';
    case 'grey':
      return grey;
    case 'lightGreen':
      return lightGreen;
    case 'darkGreen':
      return darkGreen;
    case 'pink':
      return pink;
    case 'yellow':
      return yellow;
    case 'red':
      return red;
    case 'transparent':
      return 'transparent';
    default:
      return 'transparent';
  }
}

export default colourMatching;
